export default __webpack_public_path__ + "static/media/treepic.c1c067d3.png";